import React from 'react';
import { Box, Typography, Paper, Grid2, Link, Tooltip, Avatar } from '@mui/material';
import { motion } from 'framer-motion';
import { REACT_APP_API_IMG } from '../../utlis';

const BasicDetailsCard = ({ vendor }: any) => (
	<motion.div
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ duration: 0.5 }}
	>
		<Paper sx={{ borderRadius: '10px', boxShadow: '0px 4px 4px rgba(0,0,0,0.1)' }}>
			{/* Header */}
			<Box
				sx={{
					height: 50,
					bgcolor: 'primary.main',
					display: 'flex',
					alignItems: 'center',
					pl: 3,
					borderTopLeftRadius: '12px',
					borderTopRightRadius: '12px',
					gap: 2,
				}}
			>
				{vendor?.logo && <Avatar src={`${REACT_APP_API_IMG}${vendor.logo}`}></Avatar>}
				<Typography
					color="white"
					fontWeight={600}
					fontFamily="Poppins"
					fontSize={{ xs: 14, sm: 18 }}
				>
					Vendor Details
				</Typography>
			</Box>

			{/* Content */}
			<Box sx={{ p: 3 }}>
				{/* Row 1 */}
				<Grid2 container spacing={4}>
					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Company Name
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor?.companyName}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Owner Name
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor?.ownerName}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Email Address
						</Typography>

						<Tooltip title={vendor?.email || ''} arrow>
							<Typography
								sx={{
									fontSize: { xs: '14px', sm: '16px', md: '18px' },
									fontWeight: 500,
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: 200, // adjust width as per design
									cursor: 'pointer',
								}}
								variant="subtitle1"
							>
								{vendor?.email}
							</Typography>
						</Tooltip>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Phone Number
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor?.mobile}
						</Typography>
					</Grid2>
				</Grid2>

				{/* Row 2 */}
				<Grid2 container spacing={4}>
					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Address
						</Typography>
						<Tooltip
							title={
								`${vendor?.companyAddress?.address}, ${vendor?.companyAddress?.city},{' '}
								${vendor?.companyAddress?.state}, ${vendor?.companyAddress?.country}` || ''
							}
							arrow
						>
							<Typography
								sx={{
									fontSize: { xs: '14px', sm: '16px', md: '18px' },
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: 200, // adjust width as per design
									cursor: 'pointer',
								}}
								variant="subtitle1"
								fontWeight={500}
							>
								{vendor?.companyAddress?.address}, {vendor?.companyAddress?.city},{' '}
								{vendor?.companyAddress?.state}, {vendor?.companyAddress?.country}
							</Typography>
						</Tooltip>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Business Type
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor?.companyType}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							GST Document
						</Typography>
						{vendor?.kycDetails?.gstDocument ? (
							// <a
							// 	href={vendor.kycDetails.gstDocument}
							// 	target="_blank"
							// 	rel="noreferrer"
							// >
							// 	View GST
							// </a>
							<Link
								href={vendor?.kycDetails?.gstDocument || '-'}
								target="_blank"
								rel="noreferrer"
								underline="hover"
								color="secondary"
								sx={{
									fontSize: { xs: '14px', sm: '16px', md: '18px' }, // responsive font sizes
									fontWeight: 500,
									display: 'inline-block',
								}}
							>
								View GST
							</Link>
						) : (
							<Typography variant="subtitle1" fontWeight={500}>
								-
							</Typography>
						)}
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Submitted Date
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{new Date(vendor?.createdAt).toLocaleDateString()}
						</Typography>
					</Grid2>
				</Grid2>
			</Box>
		</Paper>
	</motion.div>
);

export default BasicDetailsCard;
